@if (checked !== undefined) {
  <input type="checkbox"
    [id]="id"
    [checked]="checked"
    (change)="changed.emit($any($event.target).value)"
    [attr.disabled]="isDisabled ? 'disabled' : null"
    >
  <ng-container *ngTemplateOutlet="label"></ng-container>
}

@if (! nativeMode && renderedFormControl) {
  <input type="checkbox"
    [id]="id"
    [formControl]="renderedFormControl"
    >
  <ng-container *ngTemplateOutlet="label"></ng-container>
} @else {
  @if (nativeMode && internalFormControl) {
    <input type="checkbox"
      [id]="id"
      [formControl]="internalFormControl"
      >
    <ng-container *ngTemplateOutlet="label"></ng-container>
  }
}


<ng-template #label>
  <label [for]="id" class="label">
    <span class="label-content"
      [class.small]="smallLabel"
      >
      <ng-content></ng-content>
    </span>
  </label>
</ng-template>
